import React, { Component } from 'react';
import { connect } from 'react-redux';
import { attachmentsActions } from '../actions/attachments.actions';
import { Button, List, Row, Col, Alert, Spin, Upload, Icon, Tooltip, Modal, message } from 'antd';
import { authUploadHeader } from '../helpers/auth-header';
import { dspxSorter } from '../helpers/dspx-sort';
import moment from 'moment';
import appSettings from '../constants/app.constants'
import { requestsConstants } from './Requests/requests.constants';
import WarrantyDocumentsContainer from './warranty-documents-container';

const confirm = Modal.confirm;

class AttachmentsPanelContainer extends Component {

	constructor(props) {
		super(props)

		this.state = {
			attachments: [],
			dataFetching: false,
			fetchingIds: [],
			fetchingPreviewIds: [],
			fileList: [],
			deletedList: [],
			authUploadHeader: authUploadHeader(),
			//showUploadBox: !props.hasattachment,
		}
	}

	getAttachmentsList = () => {
		this.setState({ dataFetching: true, fetchingIds: [], fetchingPreviewIds: [] })
		attachmentsActions.fetchAttachments(this.props.request || this.props.document,
			this.props.request ? 'requests' : 'documents')
			.then(
				data => {
					data.data.sort(dspxSorter.sorterCreateDateDesc);
					this.setState({ attachments: data.data, dataFetching: false })

					if (typeof this.props.changeEntityHasAttachmentProp === 'function') {
						if (data.data?.length > 0 && !this.props.hasattachment) {
							this.props.changeEntityHasAttachmentProp(true, this.props.request);
						}
	
						if (data.data?.length === 0 && this.props.hasattachment) {
							this.props.changeEntityHasAttachmentProp(false, this.props.request);
						}
					}

					console.log('--- getAttachmentsList')
					console.log(data.data)
				},
				err => { this.setState({ dataFetching: false }); console.log(err) }
			)
	}

	componentDidMount() {
		this.getAttachmentsList();
	}

  componentDidUpdate(pp) {
    if (
      pp.request !== this.props.request ||
      pp.document !== this.props.document ||
      this.props.needUpdate
    ) {
      this.getAttachmentsList();

      if (
        this.props.needUpdate &&
        typeof this.props.resetNeedUpdate === 'function'
      ) {
        this.props.resetNeedUpdate();
      }
    }
  }

	handleAtachementDownload = (item, itemName) => {
		this.setState(({fetchingIds}) => ({ fetchingIds: [...fetchingIds, item.id] }))
		attachmentsActions.fetchAttachment(item.requestId || item.docId, item.fileName, itemName,
				item.requestId ? 'requests':'documents')
		.then(
		data => {
			this.setState(({ fetchingIds }) => {
				const index = fetchingIds.indexOf(item.id)
				const newIds = fetchingIds.slice()
				newIds.splice(index, 1)
				return { fetchingIds: newIds,};})
		},
		err => {
			this.setState(({ fetchingIds }) => {
				const index = fetchingIds.indexOf(item.id)
				const newIds = fetchingIds.slice()
				newIds.splice(index, 1)
				return { fetchingIds: newIds,};})
				console.log(err)
		})
	}

	handleAtachementPDF = (item, itemName) => {
		this.setState(({fetchingPreviewIds}) => ({ fetchingPreviewIds: [...fetchingPreviewIds, item.id] }))
		attachmentsActions.openAttachment(item.requestId || item.docId, item.fileName, itemName,
				item.requestId ? 'requests':'documents')
		.then( data => {
				this.setState(({ fetchingPreviewIds }) => {
					const index = fetchingPreviewIds.indexOf(item.id)
					const newIds = fetchingPreviewIds.slice()
					newIds.splice(index, 1)
					return { fetchingPreviewIds: newIds,};})
		},
		err => {
			this.setState(({ fetchingPreviewIds }) => {
				const index = fetchingPreviewIds.indexOf(item.id)
				const newIds = fetchingPreviewIds.slice()
				newIds.splice(index, 1)
				return { fetchingPreviewIds: newIds,};})
				console.log(err)
		})
	}

	handleAtachementDelete = (item, itemName) => {
		confirm({
			title: 'Удалить вложение?',
			content:
				<div>
					<strong>{itemName}</strong></div>,

			onOk: () => {
				this.setState({ dataFetching: true, fetchingIds: [], fetchingPreviewIds: [] })
				attachmentsActions.deleteAttachment(this.props.request || this.props.document,
					item.id, this.props.request ? 'requests':'documents')
					.then(
						() => {
							this.getAttachmentsList();
						},
						err => { this.setState({ dataFetching: false }); console.log(err) })
					},
			onCancel: () => {

			},
		})
	}

	handleAtachementOneDelete = (item, itemName) => {

		this.props.dispatch({
			type: requestsConstants.SHOW_MODAL,
			payload: {},
		})

		this.setState(({deletedList}) => ({ deletedList: [...deletedList, item.id] }))

		const deleteItem = ({deletedList}) => {
			const index = deletedList.indexOf(item.id)
			const newIds = deletedList.slice()
			newIds.splice(index, 1)
			return { deletedList: newIds };
		}

		confirm({
			title: 'Удалить вложение?', 
			content:
				<div>
					<strong>{itemName}</strong></div>,

			onOk: () => {
				attachmentsActions.deleteOneAttachment(this.props.request || this.props.document, item.id)
					.then(
						() => {
							this.setState(deleteItem)
							this.getAttachmentsList();
						},
						err => {
							this.setState(deleteItem);
							console.log(err)
						})
						
						this.props.dispatch({
							type: requestsConstants.HIDE_MODAL,
						})
				
					},
			onCancel: () => {
				this.setState(deleteItem);
				this.props.dispatch({
					type: requestsConstants.HIDE_MODAL,
				})
			},
		})
	}

	handleAtachementPreview = async (item, itemName) => {
		this.setState(({fetchingPreviewIds}) => ({ fetchingPreviewIds: [...fetchingPreviewIds, item.id] }))
		const data = await attachmentsActions.previewAttachment(item.requestId || item.docId, item.fileName, itemName,
			item.requestId ? 'requests':'documents')

    const previews = this.state.attachments.filter((e) => {
      const fn = e.name.split('.');
      const ex = fn[fn.length - 1].toLowerCase();
      return ex === 'jpg' || ex === 'jpeg' || ex === 'png' || ex === 'gif' || ex === 'webp';
    });
      

		const currentPreview = previews.findIndex(e=>e.id===item.id)

		this.props.dispatch({
			type: requestsConstants.SHOW_PREVIEW,
			payload: {url: data, fileName: itemName, previews },
		})

		this.props.dispatch({
			type: requestsConstants.SET_PREVIEW_INDEX,
			payload: { currentPreview },
		})

		this.setState(({ fetchingPreviewIds }) => {
			const index = fetchingPreviewIds.indexOf(item.id)
			const newIds = fetchingPreviewIds.slice()
			newIds.splice(index, 1);
			return { fetchingPreviewIds: newIds,};})
	}

	beforeUpload = file => {
    const mb = 64;
    if (file.size > mb * 1024 * 1024) {
      message.error(`Файл должен весить не больше ${mb} мб`);
      return false;
    }
		this.setState(({ fileList }) => ({
			fileList: [...fileList, file],
		}));
		return true;
	}

	onFileListChange = obj => {
		const { file } = obj;
    if (file.status === 'uploading' || (file.percent && file.percent < 100)) {
      this.setState({ dataFetching: true });
    } else {
      this.getAttachmentsList();
    }
		if (file && file.status === 'done') {
			this.setState({ fileList: [] });
		}
	}

	onFileListRemove = file => {
		this.setState(({ fileList }) => {
			const index = fileList.indexOf(file);
			const newFileList = fileList.slice();
			newFileList.splice(index, 1);
			return {
				fileList: newFileList,
			};
		});
	}

	renderAttachmentsListItem = item => {
		const deleteVisible = item.canBeDeleted && !this.props.hideActions;

		const listItemStyle = {
			borderBottom: 'none',
			//margin-bottom: 4px !important;
			//font-size: 14px !important
		}

		const dt = item.createDate
		const fn = item.name.split('.')
		const ex = fn[fn.length - 1]
		let bi
		switch (ex.toLowerCase()) {
			case 'txt':
				bi = 'file-text';
				break;
			case 'doc':
			case 'docx':
				bi = 'file-word';
				break;
			case 'xls':
			case 'xlsx':
				bi = 'file-excel';
				break;
			case 'pdf':
				bi = 'file-pdf';
				break;
      case 'webp':
			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'gif':
				bi = 'picture';
				break;
			case 'zip':
			case '7z':
			case 'rar':
				bi = 'file';
				break;     
			default:
				bi = 'file-unknown';
		}

		const itemName = item.name && item.name.replace(/image_picker_/,'image').replace(/\.jpg\.jpg/,'.jpg')

		return (
			<List.Item key={item.id} style={listItemStyle} className='dspx-attach-document'>
				<Row gutter={0} >
				{ item.docId && this.state.attachments.length > 1 && !this.props.hideActions && <div style={{position:'absolute', left:'-25px',  width:'100%', height:'100%'}}>
					<Tooltip title='Удалить вложение' placement="left"  >
            <Icon type="minus-circle" className='dspx-attach-document-delete-button'
              onClick={(e)=>{
								e.stopPropagation();
								this.handleAtachementDelete(item, itemName);
              }} />
          </Tooltip>
							</div> }
					<Col span={2} style={{textAlign:'left', position:'relative'}} >
						<Icon type={bi} style={{fontSize:22,
							color: bi === 'picture' ? "#67b2ff" :
							bi === 'file-pdf' ? "#ff7a7a" : "#949899", marginTop:4}}/>
					</Col>
					<Col span={deleteVisible ? 16 : 18} >
						<Row gutter={0}>
							<Col span={11} >
								<span style={{ whiteSpace: 'nowrap', fontSize: '12px' }}>
									{ moment(dt).format('DD.MM.YYYY HH:mm:ss') }
								</span>
							</Col>
							<Col span={12} style={{textAlign:"right"}}>
								<span
                  style={{
                    whiteSpace: 'nowrap',
                    fontSize: '12px',
                    marginRight: 10,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Icon type="user" style={{ color: '#999', marginRight: 3 }} />
                  <span
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    {item.user.specialityName && (
                      <span 
												style={{ 
													fontSize: '10px',
													lineHeight: 1,
													fontWeight: 700
												}}
											>
                        {item.user.specialityName}
                      </span>
                    )}
                    <span>
                      {item.user && item.user.surName}{' '}
                      {item.user && item.user.firstName}
                    </span>
                  </span>
                </span>
							</Col>
							<Col span={24} style={{width: '300px' }} >
								<div style={{ fontSize: '12px', fontWeight: 600, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>{itemName}</div>
							</Col>
						</Row>
					</Col>
					<Col span={deleteVisible ? 6 : 4} style={{textAlign: "right"}}>
						<span style={{whiteSpace: 'nowrap'}}>
							<Button shape="circle"
								icon={ this.state.fetchingIds.includes(item.id) ? "loading" : 'download'}
								onClick={() => { this.handleAtachementDownload(item, itemName)}} />
							{bi === 'picture' && <span style={{marginLeft:6}}>
								<Button shape="circle"
									icon={ this.state.fetchingPreviewIds.includes(item.id) ? "loading" : 'eye'}
									onClick={() => { this.handleAtachementPreview(item, itemName)}} /></span>}
							{bi === 'file-pdf' && <span style={{marginLeft:6}}>
								<Button shape="circle"
									icon={ this.state.fetchingPreviewIds.includes(item.id) ? "loading" : 'eye'}
									onClick={() => { this.handleAtachementPDF(item, itemName)}} /></span>}
							{deleteVisible && (
								<span style={{marginLeft:6}}>
									<Button
									  className='dspx-danger-button'
										shape="circle"
										disabled={this.state.deletedList.length>0}
										icon={ this.state.deletedList.includes(item.id) ? 'loading' : 'delete'}
										onClick={() => this.handleAtachementOneDelete(item, itemName)} />
								</span>
							)}
						</span>
					</Col>
				</Row>
			</List.Item>
		)
	}

	render() {

		const listStyle = {
			minWidth:  350,
			maxWidth: 450
		}

		const uploadDraggerProps = {
			name: 'file',
			multiple: true,
			showUploadList: true,
			beforeUpload: this.beforeUpload,
			fileList: this.state.fileList,
			headers: this.state.authUploadHeader,
			action: appSettings.apiUrl + (this.props.postUrl ? this.props.postUrl : ('/Request/add_file/' + this.props.request)),
			onChange: this.onFileListChange,
			onRemove: this.onFileListRemove,
		}

		//console.log(this.state.attachments)

		return (
			<div style={listStyle} ref={this.locRef} lockrecid={this.props.lockrecid}>

				{this.props.apiResponseError && <Alert message={this.props.apiResponseText} type="error" showIcon />}

        {!this.props.hideUploadBox && (
          <Upload.Dragger {...uploadDraggerProps}>
            <Tooltip
              mouseLeaveDelay={0}
              title="Чтобы прикрепить файл, перетащите его сюда, или нажмите чтобы выбрать"
            >
              <div>
                <Icon
                  type="file-add"
                  theme="outlined"
                />
              </div>
            </Tooltip>
          </Upload.Dragger>
        )}

				<Spin size="large" spinning={this.state.dataFetching} tip="Загрузка..." delay={100}>
					{this.state.attachments && this.state.attachments.length > 0 &&
						<List style={{ marginTop: '10px' }}
							itemLayout="vertical"
							size="small"
							className={`dspx-attach-documents`}
							pagination={{
								hideOnSinglePage: true,
								pageSize: 5,
								size: 'small',
							}}
							dataSource={this.state.attachments}
							renderItem={this.renderAttachmentsListItem} />}
				</Spin>
				{this.props.showWarrantyDocs && (
           <WarrantyDocumentsContainer
             request={this.props.request}
             canChangeWarranty={false}
             hideIfEmpty
           />
        )}
			</div>
		)
	}
}

function mapStateToProps(state) {
	const { attachmentsStore } = state;	
	return { attachmentsStore };
}

AttachmentsPanelContainer.defaultProps = {
	showWarrantyDocs: false,
	hideActions: false,
}

export default connect(mapStateToProps)(AttachmentsPanelContainer);
